/**
 * Class representing redirect request from non-portal app.
 */
export class RedirectInfo {

  /**
   * Creates a redirect info class.
   *
   * @param {string} redirect
   *    URL to redirect user back to after authentication.
   * @param {string} state
   *    State to pass back on redirect.
   */
  constructor (
    redirect = '',
    state = ''
  ) {
    this.redirect = redirect;
    this.state    = state;
  }

  /**
   * Returns the content of the object as an encoded string to be passed to
   * cognito in the state parameter so it comes back.
   */
  getAsEncodedString() {
    const asString = JSON.stringify({
      redirect: this.redirect,
      state: this.state
    });
    return encodeURIComponent(asString);
  }

  /**
   * Returns whether the redirect is an absolute path.
   *
   * Tests whether the url start with '/'.
   *
   * @returns bool
   *    Result fo the test.
   */
  isAbsolutePath() {
    return this.redirect.substring(0, 1) === '/';
  }

  /**
   * Fills the object from an encoded uri in the same format as generated by
   * getAsEncodedString.
   * @param {string} string 
   */
  fillFromEncodedString(string) {
    try {
      const asString = decodeURI(string);
      const asObject = JSON.parse(asString);
      this.redirect  = asObject.redirect;
      this.state     = asObject.state;
    } catch (error) {
      console.error(['Failed to parse string into RedirectInfo object.', string]);
    }
  }
}
